import React, {useState} from "react"
import MetaTags from 'react-meta-tags';
import {
  Container, 
  Card, CardBody,
  CardTitle, CardSubtitle,
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  Button,
} from "reactstrap"
import { Link } from "react-router-dom"
import { get } from "../../helpers/api_helper"
import * as url from "../../helpers/url_helper"

import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';

const products = [ 
  {id: 1, name: 'Has vedor done the PPM', type: 'radio', options: 'Yes/No'},
  {id: 2, name: 'Remarks', type: 'remark', options: ''},
 ];


const columns = [{
  dataField: 'id',
  text: '#'
}, {
  dataField: 'label',
  text: 'Field Label',
},  {
  dataField: 'type',
  text: 'Input Type',
},  {
  dataField: 'unit_of_measure',
  text: 'Unit of Measure',
}, 
{
  dataField: 'options',
  text: 'Options',
},
{
  dataField: 'min',
  text: 'Field Min',
},
{
  dataField: 'max',
  text: 'Field Max',
},
{
  dataField: 'warning_min',
  text: 'Warning Min',
},
{
  dataField: 'warning_max',
  text: 'Warning Max',
},
{
  dataField: 'alert_on',
  text: 'Alert on',
  formatter: (cell, row, rowIndex)=> {
    return row.alert_on == 'null' ? '' : row.alert_on;
  }
},
];

const Form = props => {

  // const { id } = ;

  const [loading, setLoading] = React.useState(true);
  const [form, setForm] = React.useState(null);
  const [fields, setFields] = React.useState([]);

  const fetchData = () => {
    setLoading(true);
      console.log('::ID:', props.location.state.id);
      get(url.GET_FORM+'/'+props.location.state.id).then(response => {
      console.log('RESP', response);
      if(response.status == 200) {
        setForm(response.data.form);
        setFields(response.data.fields);
        setLoading(false);
      }
      else {
        setForm(null);
        setFields(null);
        setLoading(false);
      }
    })
    .catch(error => {
      console.log('err:', error);
    });
  };

  React.useEffect(()=>{
    fetchData();
  }, []);

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Edit Form </title>
        </MetaTags>
        <Container fluid>
          <div className="d-flex justify-content-between align-items-center">
            <h3 className="mb-4">Form Preview</h3>
            {/* <Link className="btn btn-secondary" to="/forms/index">Back</Link> */}
          </div>
            <Card>
            <CardBody>
                {/* <CardTitle tag="h3">Create</CardTitle> */}
                {/* <CardSubtitle tag="h5" className="mb-4 text-muted">22 Jul 2021</CardSubtitle> */}

              <BootstrapTable keyField='id' data={ fields } columns={ columns } filter={ filterFactory() } pagination={ paginationFactory() } />

    <div className="mb-4 container">
      <div className="d-flex justify-content-center">
        <Link className="btn btn-light" to="/forms/index">Back</Link>
      </div>
    </div>
            </CardBody>
            </Card>

        </Container>
      </div>
    </React.Fragment>
  )
}

export default Form
